export default __webpack_public_path__ + "static/media/css.01e3a5f0.svg";